﻿import * as React from 'react';

export type ContainerSizeAndPosition = {
    left: number;
    right: number;
    width: number;
};

export function useCalendarContainerWidth(
    containerRef: React.MutableRefObject<HTMLDivElement>,
    dependencies?: any[]
): ContainerSizeAndPosition {
    let [containerSizeAndPosition, setContainerSizeAndPosition] =
        React.useState<ContainerSizeAndPosition>({
            left: 0,
            right: 0,
            width: 0
        });
    React.useLayoutEffect(() => {
        if (containerRef.current) {
            let boundingClientRect = containerRef.current.getBoundingClientRect();
            let sizeAndPosition = {
                left: boundingClientRect.left,
                right: boundingClientRect.right,
                width: boundingClientRect.width
            };
            if (
                sizeAndPosition.left !== containerSizeAndPosition.left ||
                sizeAndPosition.right !== containerSizeAndPosition.right ||
                sizeAndPosition.width !== containerSizeAndPosition.width
            ) {
                setContainerSizeAndPosition(sizeAndPosition);
            }
        }
    }, [containerSizeAndPosition, ...dependencies]);
    return containerSizeAndPosition;
}
